module.exports = __webpack_public_path__ + "img/bg_title.b1ca13d7.jpg";